import { debug as baseDebug } from '@skinsoft/debug';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

import { Message } from './types';

const debug = baseDebug('bus');

export const subject = new Subject<Message>();

export function emit(topic: string, payload?: any) {
    debug('emit', topic, payload);
    subject.next({ topic, payload });
}

const filterTopic = topic => (source: Observable<Message>): Observable<Message> =>
    source.pipe(filter(message => message.topic === topic));

export const listen$ = (topic: any) => subject.pipe(filterTopic(topic));
